import React from "react";
import CommonLayout from "./CommonLayout";
import moment from "moment/moment";
import { orderBy } from "lodash";
import ButtonSecondary from "../../shared/Button/ButtonSecondary";
import { useProviders } from "../../hooks/collections/useProviders";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";
import useModal from "../../@shared/components/Modal/hooks/useModal";
import { Avatar } from "@mui/material";
import { AccountProviderForm } from "../AccountPage/ServiceForm/AccountProviderForm";
import { NotFound } from "../../components/NotFound/NotFound";

const AccountCompanyProviders = () => {
  const modal = useModal();
  const { providers } = useProviders(true);

  const handleOpenProviderForm = (provider?: any) => {
    modal.open({
      title: provider ? "Edit Provider" : "Create Provider",
      content: <AccountProviderForm provider={provider}/>,
      size: "lg"
    });
  };

  const renderProvidersSection = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div className="flex flex-col md:flex-row gap-5 items-center justify-between">
          <h2 className="text-3xl font-semibold">Company Providers</h2>
          <ButtonPrimary onClick={() => handleOpenProviderForm()} className={"p-2"}>Create</ButtonPrimary>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className={"overflow-x-auto"}>
          {providers.length ? (
            <table className={"w-full text-left min-w-[1000px] border-separate border-spacing-4"}>
              <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Created</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              {orderBy(providers, ["createdAt"], ["desc"]).map((provider: any) => (
                <tr key={provider.id}>
                  <td className={"flex gap-2 items-center"}>{provider?.imageUrl &&
                    <Avatar src={provider.imageUrl}/>} {provider.name} </td>
                  <td>{provider.email}</td>
                  <td>{moment(provider.createdAt).format("YYYY-MM-DD")}</td>
                  <td>
                    <div className={"flex gap-2"}>
                      <ButtonSecondary onClick={() => handleOpenProviderForm(provider)}>Edit</ButtonSecondary>
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          ) : (
            <NotFound description={"No providers found for your company."} />
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <CommonLayout>{renderProvidersSection()}</CommonLayout>
    </div>
  );
};

export default AccountCompanyProviders;
